





















































import Vue from 'vue';
import {
  calender,
  buyer as buyerM,
  Buyer,
  buyerCompany,
  BuyerCompany,
} from 'mostra';

interface DataType {
  buyer: Buyer | null;
  company: BuyerCompany | null;
  loading: boolean;
}

export default Vue.extend({
  name: 'admin-buyer-edit',
  data(): DataType {
    return {
      buyer: null,
      company: null,
      loading: true,
    };
  },
  methods: {
    formatDateTime(dt: any) {
      return calender.formatDateTime(dt);
    },
    async onSubmitUpdateBuyer(buyer: Buyer) {
      if (!buyer) throw new Error('buyer is null');
      this.$loading(true);
      try {
        const uid = this.$auth.uid;
        const updatedBuyer = await buyerM.save(uid, buyer);
        this.buyer = updatedBuyer;
        this.$success('担当者情報を保存しました。');
      } catch (error: any) {
        this.$error('担当者情報の保存に失敗しました。', error);
      } finally {
        this.$loading(false);
      }
    },
    async onSubmitUpdateCompany(company: BuyerCompany) {
      if (!company) throw new Error('company is null');
      this.$loading(true);
      try {
        const uid = this.$auth.uid;
        const updatedCompany = await buyerCompany.save(uid, company);
        this.company = updatedCompany;
        this.$success('企業情報を保存しました。');
      } catch (error: any) {
        this.$error('企業情報の保存に失敗しました。', error);
      } finally {
        this.$loading(false);
      }
    },
    async fetchData() {
      this.loading = true;
      this.$loading(true);
      try {
        const cid = this.$route.params.id;
        this.buyer = await buyerM.loadByCID(cid);
        if (!this.buyer) throw new Error('buyer is null');
        this.company = await buyerCompany.load(cid);
        if (!this.company) throw new Error('company is null');
      } catch (error: any) {
        this.$fatal(error);
      } finally {
        this.loading = false;
        this.$loading(false);
      }
    },
  },
  async mounted() {
    await this.fetchData();
  },

});
